import { render, staticRenderFns } from "./ModalZoneEdit.vue?vue&type=template&id=5b290803&"
import script from "./ModalZoneEdit.vue?vue&type=script&lang=js&"
export * from "./ModalZoneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports